const { $ } = window;
//const $body = $( document.body );

export default {
	init() {
		// CTA()
	},
	finalize() {},
};